<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(20)">
    <span>{{ 'menus.reload-data' | translate }} </span>
  </div>
  <div *ngIf="!isInOffline" class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(1)">
    <span>{{ 'menus.delete' | translate }} </span>
  </div>
  <div
    *ngIf="currentPerson?.isHost && isConnection"
    class="ir-btn ir-btn--big th-btn-menulevel"
    (click)="selectMenu(10)"
  >
    <span>{{ 'menus.edit-json' | translate }} </span>
  </div>
</div>
